import React from 'react';
import styleService from '@nykaa/deals-utils/styles';
import utils from '@nykaa/deals-utils/basic';
import styled from '../../../theme';
import CONFIGURATIONS from '../constants';
const { getPaddingStyles, getMarginStyles, getFontStyles, getBKGStyles, setVisibility, } = styleService.utils;
export const RatingsStyled = styled.div `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ bkg }) => getBKGStyles(bkg)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: ${({ cornerRadius }) => cornerRadius.web};
  .actual-rating {
    display: flex;
    margin-right: 2px;
    ${({ actualRatingtext }) => getFontStyles(actualRatingtext)}
  }
  .rating-icon {
    background-size: 16px 16px;
    background-position: cover;
    background-repeat: no-repeat;
    background-image: url(https://images-static.naikaa.com/media/wysiwyg/2023/core/star.svg);
  }
  .rating-count {
    display: flex;
    ${({ maxRatingtext }) => getFontStyles(maxRatingtext)};
  }
  ${({ visible, visibility }) => visibility && setVisibility(visible)};
`;
const Ratings = ({ style, ratingCount, rating, visibility, }) => {
    var _a;
    const { nFormatter } = utils;
    const ratingsDisplay = ` ${(_a = Number(rating || 0)) === null || _a === void 0 ? void 0 : _a.toFixed(1)}`;
    const ratingCountDisplay = ` (${nFormatter(ratingCount, 1)})`;
    return (!!rating && (React.createElement(RatingsStyled, Object.assign({}, style, { visibility: visibility }),
        React.createElement("span", { className: "actual-rating" },
            ratingsDisplay,
            "\u2605"),
        React.createElement("span", { className: "rating-count" }, ` /${CONFIGURATIONS.MAX_RATING_COUNT} ${ratingCountDisplay}`))));
};
export default Ratings;
